import { useEffect } from 'react'
import {getListMeasurementUnits} from '../../../services/sKPI/measurementUnit.service'


const useGetMeasurementUnitsMaintainer = (mantainerList, setMantainer) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListMeasurementUnits();
                const response = serviceResponse.data;
                const aux_array = [];

                response.data.forEach(element => {
                    aux_array.push({id: element.id , name: element.name, description: element.description, measurementCode: element.measurementCode, measurementNemo: ""})
                });

                setMantainer(aux_array);
            }
            catch (error) {
                setMantainer([]);
            }
        }
        
        if (mantainerList === null) {
            getData()
        }
    }, [mantainerList, setMantainer]);
}

const useGetMeasurementUnit = (contracts, setContracts) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListMeasurementUnits();
                const response = serviceResponse.data;
                const aux_array = [];

                response.data.forEach(element => {
                    aux_array.push({
                        key: element.id,
                        text: `${element.name}`,
                        title:  `${element.name}`})
                });

                setContracts(aux_array);
            }
            catch (error) {
                setContracts([]);
            }
        }
        
        if (contracts === null) {
            getData()
        }
    }, [contracts, setContracts]);
}

export {
    useGetMeasurementUnitsMaintainer,
    useGetMeasurementUnit
}